import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "flex items-center justify-center space-x-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-center" }, "Put your SVG image here.", -1)
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex-item"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "flex-item"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "flex justify-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "OK!", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://goerlifaucet.com",
    class: "underline",
    target: "_blank"
  }, "Get Free Goerli ETH")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mx-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-xl font-bold" }, " Convert SVG with simple structure to full on-chain NFT "),
  /*#__PURE__*/_createElementVNode("li", null, "All data is converted to the d attribute of the path element."),
  /*#__PURE__*/_createElementVNode("li", null, " Only circle, ellipses, line, rect, polygon, polyline element are converted to the d attribute of the path element. All other elements are ignored. "),
  /*#__PURE__*/_createElementVNode("li", null, " g elements are expanded. nested g elements are expanded to flat. "),
  /*#__PURE__*/_createElementVNode("li", null, "Fill is retained"),
  /*#__PURE__*/_createElementVNode("li", null, " stroke and stroke-width are supported. stroke-linecap:round;stroke-linejoin:round can be specified to add stroke. "),
  /*#__PURE__*/_createElementVNode("li", null, " Size of image is normalized to 1024*1024 based on viewBox or SVG properties width, height. ")
], -1)
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://testnets.opensea.io/ja/collection/svgtokenv1-4?search[sortAscending]=false&search[sortBy]=CREATED_DATE",
    class: "underline",
    target: "_blank"
  }, "See NFTs on OpenSea")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkGate = _resolveComponent("NetworkGate")!
  const _component_TokenActions = _resolveComponent("TokenActions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onDrop: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        class: "relative mx-4 mt-4 h-24 w-48 border-4"
      }, [
        _createElementVNode("div", {
          onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragFile && _ctx.dragFile(...args))),
          class: "absolute h-full w-full text-left"
        }, [
          _createElementVNode("input", {
            type: "file",
            multiple: "",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
            class: "absolute h-full w-full opacity-0"
          }, null, 32),
          _hoisted_3
        ], 32)
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.svgData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(" Original SVG"),
            _hoisted_6,
            _createElementVNode("img", {
              src: _ctx.svgData,
              class: "mx-4 mt-4 h-48 w-48"
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      (_ctx.convedSVGData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createTextVNode(" NFT Image"),
            _hoisted_9,
            _createElementVNode("img", {
              src: _ctx.convedSVGData,
              class: "mx-4 mt-4 h-48 w-48"
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_NetworkGate, { expectedNetwork: _ctx.chainId }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.set_price) = $event)),
              maxlength: "512",
              minlength: "1",
              class: "border-1 my-2 rounded-sm bg-gray-100 text-sm text-sm text-slate-500 file:text-gray-800 hover:bg-white"
            }, null, 512), [
              [_vModelText, _ctx.set_price]
            ]),
            (_ctx.isExecuting == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mint && _ctx.mint(...args))),
                  disabled: !_ctx.existData,
                  class: _normalizeClass(["mb-2 inline-block cursor-pointer rounded px-6 py-2.5 leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg", 
              _ctx.existData
                ? 'bg-green-600 focus:bg-green-700'
                : 'bg-green-600 bg-opacity-20 focus:bg-green-700'
            ])
                }, " mint ", 10, _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.isExecuting == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "waiting ..."))
              : _createCommentVNode("", true),
            (_ctx.isExecuting == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createTextVNode(" Complete !! "),
                  _createElementVNode("div", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isExecuting = 0))
                  }, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_18,
          _hoisted_19
        ]),
        _: 1
      }, 8, ["expectedNetwork"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token, k) => {
        return (_openBlock(), _createElementBlock("div", {
          key: k,
          class: "mx-8"
        }, [
          _createElementVNode("img", {
            src: token.data.image,
            class: "w-36 border-2"
          }, null, 8, _hoisted_20),
          _createTextVNode(" " + _toDisplayString(token.data.name) + " " + _toDisplayString(token.owner) + " ", 1),
          _createVNode(_component_TokenActions, { token_obj: token }, null, 8, ["token_obj"])
        ]))
      }), 128))
    ]),
    _hoisted_21
  ]))
}